import authentication from "@irati/auth";
import client from "@irati/utils/services/apollo";
import { store } from "@irati/store";
import WalletActions from "@irati/wallet/store/actions/Wallet";
import makePaymentCardPayload, { makePaymentRewardWalletPayload, makePaymentWalletPayload, makeZipPayload } from "../utils/makePaymentPayload";
import getPaymentOrderQuery from "./queries/GetPaymentOrder";
import payByCardMutation from "./mutations/PayByCardMutation";
import payByWalletMutation from "./mutations/PayByWalletMutation";
import payByZipMutation from "./mutations/PayByZipMutation";
import { PaymentProvider } from "../enums";
var Payments = /** @class */ (function () {
    function Payments() {
    }
    Payments.prototype.getPaymentOrder = function (id, _a) {
        var _b = (_a === void 0 ? {} : _a).forceRefetch, forceRefetch = _b === void 0 ? false : _b;
        var fetchPolicy = forceRefetch ? "network-only" : "cache-first";
        var variables = { id: id };
        return client.query({ query: getPaymentOrderQuery, variables: variables, fetchPolicy: fetchPolicy }).then(function (_a) {
            var data = _a.data;
            return data.paymentOrder;
        });
    };
    Payments.prototype.payByCard = function (paymentOrder, details) {
        var variables = {
            details: makePaymentCardPayload(authentication.userPaymentProvider(), paymentOrder, details),
            paymentOrderId: paymentOrder.uuid
        };
        return client.mutate({ mutation: payByCardMutation, variables: variables }).then(function (_a) {
            var data = _a.data;
            return data.paymentPayByCard;
        });
    };
    Payments.prototype.payByAdyenDropIn = function (paymentOrder, details, channel) {
        var variables = {
            details: makePaymentCardPayload(PaymentProvider.Adyen, paymentOrder, details, channel),
            paymentOrderId: paymentOrder.uuid
        };
        return client.mutate({ mutation: payByCardMutation, variables: variables }).then(function (_a) {
            var data = _a.data;
            return data.paymentPayByCard;
        });
    };
    Payments.prototype.payByUserWallet = function (paymentOrder, _a, deal, redemptionId) {
        var amount = _a.amount;
        var variables = {
            details: makePaymentWalletPayload(paymentOrder, { amount: amount }, deal, redemptionId),
            paymentOrderId: paymentOrder.uuid
        };
        return client
            .mutate({ mutation: payByWalletMutation, variables: variables })
            .then(function (_a) {
            var data = _a.data;
            return data.paymentPayByWallet;
        })
            .then(function (payment) {
            store.dispatch(WalletActions.get());
            return payment;
        });
    };
    Payments.prototype.payByRewardWallet = function (paymentOrder, _a, rewardOrder) {
        var amount = _a.amount;
        return makePaymentRewardWalletPayload(paymentOrder, { amount: amount }, rewardOrder).then(function (details) {
            var variables = {
                details: details,
                paymentOrderId: paymentOrder.uuid
            };
            return client
                .mutate({ mutation: payByWalletMutation, variables: variables })
                .then(function (_a) {
                var data = _a.data;
                return data.paymentPayByWallet;
            })
                .then(function (payment) {
                store.dispatch(WalletActions.get());
                return payment;
            });
        });
    };
    Payments.prototype.payByZip = function (paymentOrder, details) {
        var variables = {
            details: makeZipPayload(paymentOrder, details),
            paymentOrderId: paymentOrder.uuid
        };
        return client.mutate({ mutation: payByZipMutation, variables: variables }).then(function (_a) {
            var data = _a.data;
            return data.paymentPayByZip;
        });
    };
    return Payments;
}());
var paymentService = new Payments();
export var getPaymentOrder = paymentService.getPaymentOrder;
export var payByCard = paymentService.payByCard;
export var payByAdyenDropIn = paymentService.payByAdyenDropIn;
export var payByUserWallet = paymentService.payByUserWallet;
export var payByRewardWallet = paymentService.payByRewardWallet;
export var payByZip = paymentService.payByZip;
export default paymentService;
